<template>

  <div>
    <p>Your current role is <strong>1</strong>.</p>

    <h4>You are in home.</h4>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
}
</script>
